import { IMG_BG_CLASS_NAME } from '../../../components/Section/constants';
import ImageHelper from '../../helpers/image';
import dom from '../../wrapper/DomWrapper';
import WidgetWrapper from '../../wrapper/WidgetWrapper';

import GlideSlider from './GlideSlider';

class Slider extends WidgetWrapper {
  init = () => {
    const elSliders = dom.getCollection(this.selector);

    elSliders.forEach((element) => {
      const { widgetId = null, settings } = element.dataset;
      const options = JSON.parse(settings);

      if (!widgetId) return;

      const elBg = dom.getElement(`.${IMG_BG_CLASS_NAME}`, element);
      const imgBg = new ImageHelper(elBg);

      imgBg.init();
      GlideSlider(widgetId, element, options);
    });
  };
}

export default Slider;
